import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { HeaderRow, ResultsColumn, ResultsColumnHeader, Row } from '../../../DTInfoWidget.styles';
import { formatCentsToDollars, formatOrderDateToLocalTime, priceFormat } from '../../../../../../util';

const RemediationsTable = ({ remediations }) => {
  if (isEmpty(remediations)) {
    return (
      <HeaderRow>
        <ResultsColumn>No data to display</ResultsColumn>
      </HeaderRow>
    );
  }

  return (
    <>
      <HeaderRow>
        <ResultsColumnHeader>TYPE</ResultsColumnHeader>
        <ResultsColumnHeader>NAME</ResultsColumnHeader>
        <ResultsColumnHeader>AMOUNT</ResultsColumnHeader>
        <ResultsColumnHeader>DATE</ResultsColumnHeader>
      </HeaderRow>
      {remediations.map((remediation, idx) => (
        <Row key={idx} className="fs-block">
          <ResultsColumn>{remediation.remediationType}</ResultsColumn>
          <ResultsColumn>{remediation.displayName || 'N/A'}</ResultsColumn>
          <ResultsColumn>
            {remediation.amount ? priceFormat(formatCentsToDollars(remediation.amount)) : 'N/A'}
          </ResultsColumn>
          <ResultsColumn>{formatOrderDateToLocalTime(remediation.created, 'custom_rbi') || 'N/A'}</ResultsColumn>
        </Row>
      ))}
    </>
  );
};

export default RemediationsTable;
